import { TYPE_LINK } from "shared/utils/constants";
import { Button } from "shared/components/Button";
import { MaxWidth } from "shared/components/MaxWidth";
import { SMALL } from "shared/utils/constants";
import styles from "./ButtonGroup.module.css";

export const ButtonGroupContainer = ({ items, size = SMALL }) => (
  <div className="ButtonGroupContainer">
    <MaxWidth size={size}>
      <ButtonGroup items={items} />
    </MaxWidth>
  </div>
);

export const ButtonGroup = ({ items }) => (
  <div className={styles.container}>
    {items.map(({ href, label, isDownload, page, type }) => (
      <div
        key={`${label}/${href}`}
        className={
          type === TYPE_LINK ? styles.linkWrapper : styles.buttonWrapper
        }
      >
        <Button href={href} isDownload={isDownload} page={page} type={type}>
          {label}
        </Button>
      </div>
    ))}
  </div>
);
